import { render, staticRenderFns } from "./menuSelect.vue?vue&type=template&id=859b791c&scoped=true&"
import script from "./menuSelect.vue?vue&type=script&lang=js&"
export * from "./menuSelect.vue?vue&type=script&lang=js&"
import style0 from "./menuSelect.vue?vue&type=style&index=0&id=859b791c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "859b791c",
  null
  
)

export default component.exports